.container {
  width: 100%;
  padding: 16px 16px 64px;
  height: 100%;
}

.bottomBorder {
  width: 0;
  height: 0;
}
